export default "__VITE_ASSET__BthsxTZA__"